import React from 'react';
import AutomaticStateTransitionGeneralDataContainer from './generalData/AutomaticStateTransitionGeneralDataContainer';
import StateTransitionListContainer from './stateTransitions/StateTransitionListContainer';
import PropTypes from 'prop-types';
import { FakeText, Card } from '@totalsoft/rocket-ui';
import { useQuery } from 'hooks/apollo';
import { AUTOMATICSTATETRANSITION_QUERY } from '../../queries';

const AutomaticStateTransitionContainer = ({ automaticStateTransitionId, onRedirect }) => {
  const { data, loading } = useQuery(AUTOMATICSTATETRANSITION_QUERY, {
    variables: {
      automaticStateTransitionId: automaticStateTransitionId
    },
    skip: !automaticStateTransitionId
  });

  return !loading ? (
    <>
      <AutomaticStateTransitionGeneralDataContainer
        automaticStateTransitionId={automaticStateTransitionId}
        data={data?.automaticStateTransition}
        onRedirect={onRedirect}
      />
      {automaticStateTransitionId && (
        <StateTransitionListContainer
          automaticStateTransitionId={data?.automaticStateTransition.automaticStateTransitionId}
          documentTypeId={data?.automaticStateTransition.documentTypeId}
          data={data && data.automaticStateTransition ? data.automaticStateTransition.transitionRules : []}
        />
      )}
    </>
  ) : (
    <Card>
      <FakeText lines={10} />
    </Card>
  );
};

AutomaticStateTransitionContainer.propTypes = {
  automaticStateTransitionId: PropTypes.number,
  onRedirect: PropTypes.func.isRequired
};

export default AutomaticStateTransitionContainer;
